var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChademoPlug(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_19470)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.9187 69.1513C19.3397 69.1513 5.04099 54.7288 5.04099 37.0028C5.04099 19.2767 19.3453 4.84863 36.9187 4.84863C54.4921 4.84863 68.7964 19.2711 68.7964 36.9971C68.7964 54.7232 54.4977 69.1457 36.9187 69.1457V69.1513ZM36.9187 5.27563C19.5752 5.27563 5.46715 19.507 5.46715 36.9971C5.46715 54.4872 19.5752 68.7187 36.9187 68.7187C54.2622 68.7187 68.3702 54.4872 68.3702 36.9971C68.3702 19.507 54.2622 5.27563 36.9187 5.27563Z",
    fill: "#88D5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9187 69.3142C54.611 69.3142 68.9534 54.8479 68.9534 37.0028C68.9534 19.1577 54.611 4.69135 36.9187 4.69135C19.2264 4.69135 4.88399 19.1577 4.88399 37.0028C4.88399 54.8479 19.2264 69.3142 36.9187 69.3142Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.44283 45.3405C6.44283 28.5864 19.9958 15.0067 36.7168 15.0067C53.4379 15.0067 66.9908 28.5864 66.9908 45.3405C66.9908 46.4979 66.9179 47.644 66.7946 48.7677C68.1179 45.2225 68.8469 41.3851 68.8469 37.3736C68.8469 19.5295 54.5033 5.06213 36.8122 5.06213C19.121 5.06213 4.78866 19.5295 4.78866 37.3736C4.78866 41.093 5.42229 44.6606 6.56619 47.9867C6.49329 47.1159 6.44283 46.2338 6.44283 45.3405Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.9656 0.62923C30.0217 0.623612 30.0777 0.606757 30.1338 0.59552C30.0609 0.606757 29.9656 0.623612 29.9656 0.62923Z",
    fill: "#31404C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1338 0.59553C30.1731 0.589911 30.2067 0.584293 30.2067 0.578674C30.1843 0.578674 30.1619 0.589911 30.1338 0.59553Z",
    fill: "#31404C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5891 7.67475C59.5891 7.67475 59.5723 7.7197 59.5667 7.74217C55.7986 4.80936 51.4473 2.59009 46.6979 1.28662C46.5689 1.24729 46.4456 1.21358 46.3166 1.18549C46.1147 1.13493 45.9185 1.07874 45.7166 1.03379C45.4474 0.966374 45.1839 0.91019 44.9148 0.848387C44.7241 0.809058 44.5391 0.758493 44.3484 0.719164C44.3484 0.719164 44.3484 0.724782 44.3484 0.730401C39.5429 -0.241583 34.6589 -0.230346 29.9656 0.691072V0.634888C13.4632 3.79243 0.700917 17.9958 0.0280364 35.542C-0.661666 53.4479 11.467 68.8648 28.2049 72.9269C44.2082 76.8991 61.462 69.7076 69.6095 54.4817C78.2784 38.2838 73.6748 18.5183 59.5891 7.67475ZM44.1914 5.92181C58.7424 9.32656 69.3235 22.6703 68.7235 38.1883C68.045 55.7851 53.2641 69.4997 35.7019 68.8198C33.5431 68.7356 31.4459 68.4378 29.4217 67.949C26.904 67.3253 24.4199 66.3758 22.0256 65.0892C6.53815 56.774 0.717738 37.4467 9.0222 21.9286C15.9585 8.96698 30.5488 2.76988 44.1914 5.92181Z",
    fill: "#4F6B77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8661 1.32593C46.9054 1.33716 46.9334 1.3484 46.939 1.34278C46.9166 1.33716 46.8941 1.33155 46.8661 1.32593Z",
    fill: "#31404C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6979 1.27539C46.754 1.29224 46.81 1.3091 46.8661 1.32033C46.7988 1.29786 46.7035 1.26977 46.6979 1.27539Z",
    fill: "#31404C"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.55884 45.6551C-2.74199 29.1595 5.04099 10.9502 20.607 3.58451C25.5807 1.17983 31.1095 -0.11802 36.6215 0.00558479C31.2048 0.438202 25.8498 1.91022 21.0611 4.48345C6.12882 12.2537 -1.24483 29.2719 1.55884 45.6551Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.8175 2.59009C74.1626 11.0683 81.8447 43.8516 62.8638 62.7239C60.3742 65.1735 57.5705 67.3029 54.5089 68.9322C60.3181 65.2241 65.1516 60.0102 68.2469 53.858C78.1887 34.4914 68.774 10.7368 48.8175 2.59009Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.9485 39.8176C38.9485 31.9744 45.2961 25.6143 53.1239 25.6143C60.9517 25.6143 67.2992 31.9744 67.2992 39.8176C67.2992 47.6609 60.9517 54.021 53.1239 54.021C45.2961 54.021 38.9485 47.6609 38.9485 39.8176Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9433 18.2935C23.9433 11.2762 29.6179 5.59033 36.6215 5.59033C43.6251 5.59033 49.2997 11.2762 49.2997 18.2935C49.2997 25.3109 43.6251 30.9968 36.6215 30.9968C29.6179 30.9968 23.9433 25.3109 23.9433 18.2935Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M58.8079 50.4691C66.4014 48.1647 70.6927 40.1287 68.3929 32.5203C66.093 24.9118 58.0729 20.612 50.4794 22.9164C42.8859 25.2207 38.5946 33.2567 40.8944 40.8652C43.1943 48.4736 51.2144 52.7735 58.8079 50.4691Z",
    fill: "#445B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5997 45.6704C68.5442 40.7161 68.5442 32.6836 63.5997 27.7292C58.6551 22.7749 50.6384 22.7749 45.6938 27.7292C40.7492 32.6836 40.7492 40.7161 45.6938 45.6704C50.6384 50.6248 58.6551 50.6248 63.5997 45.6704Z",
    fill: "#445B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 37C60 39.7617 57.7621 42 55 42C52.2379 42 50 39.7617 50 37C50 34.2383 52.2379 32 55 32C57.7621 32 60 34.2383 60 37Z",
    fill: "url(#paint0_linear_6_19470)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 37C51 34.7882 52.7941 33 55 33C57.2059 33 59 34.7941 59 37C59 39.2059 57.2059 41 55 41C52.7941 41 51 39.2059 51 37Z",
    fill: "#445B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 37C53 35.8969 53.8969 35 55 35C56.1031 35 57 35.8969 57 37C57 38.1031 56.1031 39 55 39C53.8969 39 53 38.1031 53 37Z",
    fill: "url(#paint1_linear_6_19470)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.6435 27.1875C61.0134 27.1875 66.2731 31.8676 67.2263 37.9804C67.2768 37.5253 67.3048 37.059 67.3048 36.5927C67.3048 29.5865 61.6358 23.9063 54.6435 23.9063C47.6511 23.9063 41.9821 29.5865 41.9821 36.5927C41.9821 37.0646 42.0102 37.5253 42.0606 37.9804C43.0139 31.8676 48.2735 27.1875 54.6435 27.1875Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.3075 44.9922C34.9281 44.9922 33.5992 45.1832 32.3431 45.5372C33.1001 43.7842 33.5263 41.8515 33.5263 39.8176C33.5263 31.8676 27.0946 25.4233 19.1603 25.4233C11.2259 25.4233 4.79427 31.8676 4.79427 39.8176C4.79427 47.7677 11.2259 54.212 19.1603 54.212C20.6967 54.212 22.177 53.9648 23.5676 53.5209C23.1807 54.6502 22.9733 55.8526 22.9733 57.0942C22.9733 63.7801 28.9451 69.1963 36.3075 69.1963C43.6699 69.1963 49.6417 63.7801 49.6417 57.0942C49.6417 50.4083 43.6699 44.9922 36.3075 44.9922Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.78867 36.6995C4.78867 28.7494 11.2203 22.3051 19.1547 22.3051C27.089 22.3051 33.5206 28.7494 33.5206 36.6995C33.5206 44.6495 27.089 51.0938 19.1547 51.0938C11.2203 51.0938 4.78867 44.6495 4.78867 36.6995Z",
    fill: "#445B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5463 49.1581C28.4128 47.8332 32.9073 41.1817 31.585 34.3016C30.2627 27.4216 23.6244 22.9182 16.7579 24.2431C9.89137 25.568 5.39687 32.2194 6.71916 39.0995C8.04144 45.9796 14.6798 50.4829 21.5463 49.1581Z",
    fill: "#445B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 37C24 39.7617 21.7621 42 19 42C16.2379 42 14 39.7617 14 37C14 34.2383 16.2379 32 19 32C21.7621 32 24 34.2383 24 37Z",
    fill: "url(#paint2_linear_6_19470)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 37C15 34.7882 16.7941 33 19 33C21.2059 33 23 34.7941 23 37C23 39.2059 21.2059 41 19 41C16.7941 41 15 39.2059 15 37Z",
    fill: "#445B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0668 36.6995C18.0668 36.0983 18.5547 35.6095 19.1547 35.6095C19.7546 35.6095 20.2425 36.0983 20.2425 36.6995C20.2425 37.3006 19.7546 37.7894 19.1547 37.7894C18.5547 37.7894 18.0668 37.3006 18.0668 36.6995Z",
    fill: "url(#paint3_linear_6_19470)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1547 27.1875C25.5246 27.1875 30.7843 31.8676 31.7375 37.9804C31.788 37.5253 31.816 37.059 31.816 36.5927C31.816 29.5865 26.147 23.9063 19.1547 23.9063C12.1623 23.9063 6.49329 29.5865 6.49329 36.5927C6.49329 37.0646 6.52133 37.5253 6.5718 37.9804C7.52504 31.8676 12.7847 27.1875 19.1547 27.1875Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.5601 56.8133C24.5601 49.9644 30.1002 44.4191 36.9299 44.4191C43.7596 44.4191 49.2997 49.9701 49.2997 56.8133C49.2997 63.6565 43.7596 69.2075 36.9299 69.2075C30.1002 69.2075 24.5601 63.6565 24.5601 56.8133Z",
    fill: "#445B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0293 56.8133C26.0293 50.7791 30.9076 45.8911 36.9299 45.8911C42.9522 45.8911 47.8306 50.7791 47.8306 56.8133C47.8306 62.8475 42.9522 67.7355 36.9299 67.7355C30.9076 67.7355 26.0293 62.8475 26.0293 56.8133Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.7784 58.1729C39.7784 60.0326 38.3654 61.5383 36.6215 61.5383C34.8776 61.5383 33.4646 60.0326 33.4646 58.1729C33.4646 56.3132 34.8776 54.8075 36.6215 54.8075C38.3654 54.8075 39.7784 56.3132 39.7784 58.1729Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.644 56.8133C33.644 54.9929 35.1131 53.5209 36.9299 53.5209C38.7467 53.5209 40.2158 54.9929 40.2158 56.8133C40.2158 58.6336 38.7467 60.1056 36.9299 60.1056C35.1131 60.1056 33.644 58.6336 33.644 56.8133Z",
    fill: "#8EC5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6215 63.7801C36.6215 63.4373 36.9019 63.1564 37.2439 63.1564C37.586 63.1564 37.8663 63.4373 37.8663 63.7801C37.8663 64.1228 37.5916 64.4037 37.2439 64.4037C36.8963 64.4037 36.6215 64.1284 36.6215 63.7801Z",
    fill: "url(#paint4_linear_6_19470)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9731 57.6167C29.3168 57.6167 29.5955 57.3375 29.5955 56.993C29.5955 56.6486 29.3168 56.3694 28.9731 56.3694C28.6293 56.3694 28.3507 56.6486 28.3507 56.993C28.3507 57.3375 28.6293 57.6167 28.9731 57.6167Z",
    fill: "url(#paint5_linear_6_19470)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.483 57.6167C44.8267 57.6167 45.1054 57.3375 45.1054 56.993C45.1054 56.6486 44.8267 56.3694 44.483 56.3694C44.1392 56.3694 43.8606 56.6486 43.8606 56.993C43.8606 57.3375 44.1392 57.6167 44.483 57.6167Z",
    fill: "url(#paint6_linear_6_19470)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6215 48.9981C36.6215 48.6554 36.9019 48.3745 37.2439 48.3745C37.586 48.3745 37.8663 48.6554 37.8663 48.9981C37.8663 49.3408 37.5916 49.6217 37.2439 49.6217C36.8963 49.6217 36.6215 49.3408 36.6215 48.9981Z",
    fill: "url(#paint7_linear_6_19470)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.9299 48.6273C42.4139 48.6273 46.9446 52.6613 47.7633 57.9201C47.8081 57.5268 47.8306 57.1279 47.8306 56.7234C47.8306 50.6892 42.9522 45.8012 36.9299 45.8012C30.9076 45.8012 26.0293 50.6892 26.0293 56.7234C26.0293 57.1279 26.0573 57.5268 26.0965 57.9201C26.9152 52.6557 31.4459 48.6273 36.9299 48.6273Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.8697 50.8618L43.1386 63.2714L43.6445 62.7692L31.3756 50.3597L30.8697 50.8618Z",
    fill: "#8EC5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0198 50.5964L30.6347 62.8895L31.1359 63.3964L43.521 51.1033L43.0198 50.5964Z",
    fill: "#8EC5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5601 17.1867C24.5601 10.3378 30.1002 4.79248 36.9299 4.79248C43.7596 4.79248 49.2997 10.3435 49.2997 17.1867C49.2997 24.0299 43.7596 29.5809 36.9299 29.5809C30.1002 29.5809 24.5601 24.0299 24.5601 17.1867Z",
    fill: "#445B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0293 17.1867C26.0293 11.1525 30.9076 6.26453 36.9299 6.26453C42.9522 6.26453 47.8306 11.1525 47.8306 17.1867C47.8306 23.2209 42.9522 28.1089 36.9299 28.1089C30.9076 28.1089 26.0293 23.2209 26.0293 17.1867Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.7784 18.5407C39.7784 20.4004 38.3654 21.9061 36.6215 21.9061C34.8776 21.9061 33.4646 20.4004 33.4646 18.5407C33.4646 16.681 34.8776 15.1753 36.6215 15.1753C38.3654 15.1753 39.7784 16.681 39.7784 18.5407Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.644 17.1867C33.644 15.3663 35.1131 13.8943 36.9299 13.8943C38.7467 13.8943 40.2158 15.3663 40.2158 17.1867C40.2158 19.007 38.7467 20.4791 36.9299 20.4791C35.1131 20.4791 33.644 19.007 33.644 17.1867Z",
    fill: "#8EC5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6215 24.1479C36.6215 23.8052 36.9019 23.5242 37.2439 23.5242C37.586 23.5242 37.8663 23.7995 37.8663 24.1479C37.8663 24.4962 37.5916 24.7715 37.2439 24.7715C36.8963 24.7715 36.6215 24.4906 36.6215 24.1479Z",
    fill: "url(#paint8_linear_6_19470)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3563 17.3608C28.3563 17.0181 28.6367 16.7372 28.9787 16.7372C29.3208 16.7372 29.6011 17.0181 29.6011 17.3608C29.6011 17.7035 29.3264 17.9845 28.9787 17.9845C28.6311 17.9845 28.3563 17.7092 28.3563 17.3608Z",
    fill: "url(#paint9_linear_6_19470)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8662 17.3608C43.8662 17.0181 44.1409 16.7372 44.4886 16.7372C44.8362 16.7372 45.111 17.0181 45.111 17.3608C45.111 17.7035 44.8362 17.9845 44.4886 17.9845C44.1409 17.9845 43.8662 17.7092 43.8662 17.3608Z",
    fill: "url(#paint10_linear_6_19470)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6215 9.36589C36.6215 9.02317 36.9019 8.74225 37.2439 8.74225C37.586 8.74225 37.8663 9.02317 37.8663 9.36589C37.8663 9.70861 37.5916 9.98953 37.2439 9.98953C36.8963 9.98953 36.6215 9.71423 36.6215 9.36589Z",
    fill: "url(#paint11_linear_6_19470)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.9299 9.00068C42.4139 9.00068 46.9446 13.0347 47.7633 18.2935C47.8081 17.9002 47.8306 17.5013 47.8306 17.0968C47.8306 11.0626 42.9522 6.17462 36.9299 6.17462C30.9076 6.17462 26.0293 11.0626 26.0293 17.0968C26.0293 17.5013 26.0573 17.9002 26.0965 18.2935C26.9152 13.0291 31.4459 9.00068 36.9299 9.00068Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.8715 11.2334L43.1404 23.6429L43.6463 23.1408L31.3774 10.7312L30.8715 11.2334Z",
    fill: "#8EC5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0217 10.966L30.6366 23.2592L31.1378 23.7661L43.5229 11.4729L43.0217 10.966Z",
    fill: "#8EC5DD"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.13
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3959 48.1217C3.7457 42.846 3.6672 29.9236 13.4352 24.9682C16.379 23.4569 19.7154 23.6423 22.9116 24.4794C19.693 23.8558 16.2557 23.7434 13.4184 25.2885C4.01485 30.3675 4.36251 42.4808 13.3959 48.1217Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.13
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9058 26.3166C35.5505 32.0024 34.9505 43.1662 27.7675 48.1216C25.5246 49.7004 22.9732 51.0488 20.2425 51.0544C22.9452 50.8353 25.4124 49.4195 27.5544 47.807C34.4178 42.7785 34.9449 32.2552 28.9058 26.3166Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.13
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.6997 48.189C39.0495 42.9134 38.971 29.991 48.739 25.0356C51.6828 23.5242 55.0192 23.7097 58.2154 24.5468C54.9967 23.9232 51.5594 23.8108 48.7221 25.3558C39.3186 30.4349 39.6663 42.5482 48.6997 48.189Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.13
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.2152 26.384C70.8599 32.0699 70.2599 43.2336 63.0769 48.1891C60.834 49.7678 58.2826 51.1162 55.5519 51.1219C58.2602 50.9027 60.7218 49.4869 62.8638 47.8744C69.7272 42.846 70.2543 32.3227 64.2152 26.384Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.13
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.0459 26.9571C23.6686 22.3781 23.663 11.4559 32.1356 7.15787C34.6926 5.84878 37.586 6.0061 40.356 6.73649C37.5635 6.19712 34.5804 6.09599 32.1188 7.43879C23.9601 11.8492 23.9377 22.1422 32.0459 26.9571Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.13
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.1166 7.87701C50.8866 12.81 50.3595 22.4961 44.1297 26.7998C42.184 28.1651 39.9691 29.3393 37.5972 29.3449C39.9467 29.1539 42.0831 27.9235 43.9447 26.5301C49.8997 22.1646 50.3539 13.0347 45.1166 7.88263V7.87701Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.13
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.973 66.4938C23.5957 61.9148 23.5901 50.9926 32.0627 46.6946C34.6197 45.3855 37.5131 45.5428 40.2831 46.2732C37.4906 45.7338 34.5075 45.6327 32.0459 46.9755C23.8873 51.3859 23.8648 61.6788 31.973 66.4938Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.13
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.2792 47.7339C51.0492 52.6669 50.5221 62.353 44.2923 66.6567C42.3466 68.022 40.1317 69.1962 37.7598 69.2019C40.1093 69.0108 42.2457 67.7804 44.1073 66.3871C50.0623 62.0216 50.5165 52.8916 45.2792 47.7396V47.7339Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_19470",
    x1: 55,
    y1: 32,
    x2: 55,
    y2: 41.9937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8F3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6_19470",
    x1: 55,
    y1: 35,
    x2: 55,
    y2: 38.9897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8F3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6_19470",
    x1: 19,
    y1: -4.52585,
    x2: 19,
    y2: -4.52585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8F3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6_19470",
    x1: 19.1547,
    y1: 35.6095,
    x2: 19.1547,
    y2: 37.7838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8F3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6_19470",
    x1: 37.2439,
    y1: 63.1564,
    x2: 37.2439,
    y2: 64.3981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8F3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6_19470",
    x1: 28.9731,
    y1: 56.3694,
    x2: 28.9731,
    y2: 57.6111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8F3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6_19470",
    x1: 44.483,
    y1: 56.3694,
    x2: 44.483,
    y2: 57.6111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8F3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6_19470",
    x1: 37.2439,
    y1: 48.3745,
    x2: 37.2439,
    y2: 49.6161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8F3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6_19470",
    x1: 37.2439,
    y1: 23.5298,
    x2: 37.2439,
    y2: 24.7715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8F3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6_19470",
    x1: 28.9731,
    y1: 16.7428,
    x2: 28.9731,
    y2: 17.9845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8F3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6_19470",
    x1: 44.483,
    y1: 16.7428,
    x2: 44.483,
    y2: 17.9845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8F3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_6_19470",
    x1: 37.2439,
    y1: 8.74787,
    x2: 37.2439,
    y2: 9.98953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8F3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE3B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_19470"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChademoPlug);
export default __webpack_public_path__ + "static/media/chademo_plug.2b21bdbdbde99364366f048628464594.svg";
export { ForwardRef as ReactComponent };